// extracted by mini-css-extract-plugin
export var linkText = "_mh-0";